import { call, select, takeEvery } from "redux-saga/effects";
import type { SagaIterator } from "redux-saga";
import type { SocketEventArchiveGenerationAction } from "types";
import { analytics } from "tools/analytics";
import type { Payload } from "tools/analytics/services/analyticsTypes";
import { showErrorMessage } from "tools/apiErrorsHelper";
import { SOCKET_EVENT_OBJECTS_SERVICES_ARCHIVE_GENERATION } from "store/api/organization/servicesExportPost/servicesExportPostActions";

interface RootState {
  accountGet?: { data?: { account?: { tenantId?: string } } };
}

const archiveDownloadEvents: Record<string, Payload> = {
  [SOCKET_EVENT_OBJECTS_SERVICES_ARCHIVE_GENERATION]: {
    event_name: "objects|services|download_export",
    tag: "Objects",
  },
};

function* downloadArchive(
  action: SocketEventArchiveGenerationAction
): SagaIterator {
  try {
    const tenantId: string | undefined = yield select(
      (state: RootState) => state.accountGet?.data?.account?.tenantId
    );
    const { url, tenantId: eventTenantId } = action.data ?? {};
    if (
      !tenantId ||
      tenantId !== eventTenantId ||
      typeof url !== "string" ||
      !url.trim()
    ) {
      return;
    }

    yield call([window, window.open], url);
    const tracker = analytics.get();
    yield call([tracker, tracker.track], archiveDownloadEvents[action.type]);
  } catch (error) {
    yield call(showErrorMessage, error);
  }
}

export default function* archiveDownloadSaga(): SagaIterator {
  yield takeEvery(Object.keys(archiveDownloadEvents), downloadArchive);
}
